















import { Vue, Component } from "vue-property-decorator";

// Data
import { DataModules } from "@/store/modules/data";

// Enums
import { ActionTypes } from "@/data/enums";

@Component({
  components: {
    "brand-gateways-table": () =>
      import("@/components/app/admin/settings/brands/brandGatewaysTable.vue")
  }
})
export default class PaymentProvidersSettings extends Vue {
  public get i18n() {
    return {
      title: this.$t("_.payment_providers"),
      addPaymentProvider: this.$t("_action.add_object", {
        object: this.$t("_.payment_provider")
          .toString()
          .toLowerCase()
      })
    };
  }

  public createPaymentProvider() {
    if (this.$userCan("create_payment_gateway")) {
      this.$store.dispatch(`data/${DataModules.GATEWAYS}/openManageGateway`, {
        actionType: ActionTypes.CREATE
      });
    }
  }
}
